<!-- 数据表单 -->
<template>
  <div class='form_wrap'>
    <!-- 数据表单 -->
    <van-form
      validate-first
      ref="attendeeForm"
      @submit="onSubmit"
      @failed="onFailed"
    >
      <transition-group name="form">
        <template v-for="item of attendeeOptions">
          <!-- input类型 -->
          <FormInputField
            :ref="item.name"
            :key="item.id"
            :option="item"
            :layout="formSty.layout"
            :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
            v-if="item.type === 'input' || item.type === 'email'"
            v-show="RelatedObj[item.name]"
            @listenInputChange="InputValueChanged"
          ></FormInputField>

          <!-- 数字输入 -->
          <FormDigit
            :ref="item.name"
            :key="item.id"
            :option="item"
            :layout="formSty.layout"
            :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
            v-if="item.type === 'digit'"
            v-show="RelatedObj[item.name]"
          ></FormDigit>

          <!-- 手机号 -->
          <FormPhone
            :ref="item.name"
            :key="item.id"
            :option="item"
            :country="countryCodeOption"
            :layout="formSty.layout"
            :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
            v-if="item.type === 'phone'"
            v-show="RelatedObj[item.name]"
            @resetValidation="resetValidation"
            @listenVerifyCodeChange="verifyCodeChange"
          ></FormPhone>

          <!-- 单选 -->
          <FormRadio
            :ref="item.name"
            :key="item.id"
            :option="item"
            :layout="formSty.layout"
            :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
            v-if="item.type === 'radio'"
            v-show="RelatedObj[item.name]"
            @listenRadioChanged="RadioOrPickerChanged"
          ></FormRadio>

          <!-- 多选 -->
          <FormCheckBox
            :ref="item.name"
            :key="item.id"
            :option="item"
            :layout="formSty.layout"
            :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
            v-if="item.type === 'verifybox'"
            v-show="RelatedObj[item.name]"
            @listenCheckboxValueChange="CheckboxValueChange"
          ></FormCheckBox>

          <!-- 多行输入 -->
          <FormTextarea
            :ref="item.name"
            :key="item.id"
            :option="item"
            :layout="formSty.layout"
            :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
            v-if="item.type === 'textarea'"
            v-show="RelatedObj[item.name]"
          ></FormTextarea>

          <!-- 选择器 -->
          <FromPicker
            :ref="item.name"
            :key="item.id"
            :option="item"
            :layout="formSty.layout"
            :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
            v-if="item.type === 'select'"
            v-show="RelatedObj[item.name]"
            @listenPickerValueChange="RadioOrPickerChanged"
          ></FromPicker>

          <!-- 时间选择 -->
          <FormDateTime
            :ref="item.name"
            :key="item.id"
            :option="item"
            :layout="formSty.layout"
            :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
            v-if="item.type === 'date'"
            v-show="RelatedObj[item.name]"
            @listenDateChanged="OptionValueChanged"
          ></FormDateTime>

          <!-- 区域选择 -->
          <FormCity
            :ref="item.name"
            :key="item.id"
            :option="item"
            :layout="formSty.layout"
            :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
            v-if="item.type === 'area'"
            v-show="RelatedObj[item.name]"
            @listenAreaMsgChanged="OptionValueChanged"
          ></FormCity>

          <!-- 图片上传 -->
          <FormUploadImage
            :ref="item.name"
            :key="item.id"
            :option="item"
            :layout="formSty.layout"
            :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
            v-if="item.type === 'image' && item.name !== 'business_card'"
            v-show="RelatedObj[item.name]"
            @listenImgListChanged="ImgListChanged"
          ></FormUploadImage>

          <!-- 名片识别 -->
          <FormBusinessCard
            :ref="item.name"
            :key="item.id"
            :option="item"
            :layout="formSty.layout"
            :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
            v-if="item.name === 'business_card'"
            v-show="RelatedObj[item.name]"
            @listenImgListChanged="ImgListChanged"
            @listenAiBusinessCard="aiBusinessCardFinish"
          ></FormBusinessCard>

          <!-- 头像/照片上传  -->
          <FormUploadPicture
            :ref="item.name"
            :key="item.id"
            :option="item"
            :layout="formSty.layout"
            :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
            v-if="item.type === 'avatar'"
            v-show="RelatedObj[item.name]"
            @listenAvatarListChanged="AvatarListChanged"
          ></FormUploadPicture>

        </template>
      </transition-group>

      <!-- 协议按钮 -->
      <!-- <div
        class="protocol_wrap"
        :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
        v-show="formConfig.is_protocol"
      >
        <van-radio
          @click="handleCheckProtocol"
          name="protocol"
          :value="protocolCheck"
          :shape="formConfig.protocol_style == 0 ? 'round' : 'square'"
          class="protocol_check"
        >
          <span class="pro_start_text">{{formConfig.protocol_prefix}}</span>
          <span
            class="pro_item"
            v-for="item of protocolList"
            :key="item.id"
            :style="{color: `${item.name_color}`}"
            @click.stop="handleClickProtocolItem(item)"
          >{{item.name}}</span>
        </van-radio>
      </div> -->

      <!-- 数据提交按钮 -->
      <!-- <van-button
        block
        class="form_subnit_btn"
        :disabled="submiting"
        :loading="submiting"
        :style="{
            borderColor: `${formSty.button.bg_color}`,
            backgroundColor: `${formSty.button.bg_color}`,
            color: `${formSty.button.color}`,
            borderRadius: `${formSty.button.redius}px`
          }"
        loading-text=""
        native-type="button"
        @click="HandleClickSubmit"
      >{{formSty.button.text}}</van-button> -->

    </van-form>
  </div>
</template>

<script>
import FormInputField from './form/FormInputField'
import FormDigit from './form/FormDigit'
import FormPhone from './form/FormPhone'
import FormRadio from './form/FormRadio'
import FormCheckBox from './form/FromCheckbox'
import FromPicker from './form/FormPicker'
import FormTextarea from './form/FormTextarea'
import FormDateTime from './form/FormDate'
import FormCity from './form/FormCity'
import FormUploadImage from './form/FormUploadImage'
import FormUploadPicture from './form/FormUploadPicture'
import FormBusinessCard from './form/FormBusinessCard'

import { relationCheck } from '@a/js/correlationCheck'
import { ObjectDeepClone } from '@a/js/utils.js'
import { ResForCheckVerifyCode } from '@a/js/api/public'

export default {
  name: 'Form',
  props: {
    formOptions: {
      type: Array,
      default: () => [],
    },
    fieldsData: {
      type: Object,
      default: () => ({}),
    },
    isSubmit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      params: {},
      formSty: {
        layout: "horizontal",
        el_margin: 0,
        el_radius: 0
      },
      formConfig: {
        is_protocol: 0,
        protocol_style: 0,
        protocol_prefix: ''
      },
      attendeeOptions: [],
      countryCodeOption: {},
      submiting: false,
      imgfieldArr: [],
      avatarfieldArr: [],
      verifyboxArr: [],
      RelatedObj: {},
      verifyCode: '',
    };
  },
  watch: {
    formOptions: {
      handler(data) {
        this.DealRelatedFieldRquire(data)
        data.map((item) => {
          if (item.type === 'verifybox') {
            this.verifyboxArr.push(item.name)
          }
        })
      },
      deep: true,
      immediate: true,
    },
    attendeeOptions: {
      handler(data) {
        // 获取国别号字段
        data.map((item) => {
          if (item.name === 'country_code') {
            this.countryCodeOption = item
          }
        })
        // 处理逻辑关联数据
        this.DealRelationShip()
        // this.CalcIsOverFlow()
      },
      deep: true,
      immediate: true,
    },
    isSubmit(val) {
      if (val) {
        this.wannaSubmit()
      }
    }
  },

  components: {
    FormInputField,
    FormDigit,
    FormPhone,
    FormRadio,
    FormCheckBox,
    FromPicker,
    FormTextarea,
    FormDateTime,
    FormCity,
    FormUploadImage,
    FormUploadPicture,
    FormBusinessCard
  },

  methods: {
    // 获取参数信息
    GetParamsData() {
      return new Promise(resolve => {
        this.params = this.$route.params;
        resolve();
      });
    },
    // 想要提交数据
    wannaSubmit() {
      this.ErgodicFormItemCheck().then(() => {
        this.$refs.attendeeForm.submit()
      })
    },
    // 遍历重置校验信息
    ErgodicFormItemCheck() {
      return new Promise((resolve) => {
        this.attendeeOptions.map((item) => {
          if (item.isRelated && !item.isRequire) {
            this.$refs.attendeeForm.resetValidation(item.name, '')
          }
        })
        resolve()
      })
    },
    // 处理字段关联必填
    DealRelatedFieldRquire(data) {
      let datas = ObjectDeepClone(data)
      datas.map(item => {
        if (item.isRelated && item.isRequire) {
          item.tempRequire = true
          item.isRequire = false
        }
      })
      this.attendeeOptions = ObjectDeepClone(datas)
      // console.log(this.attendeeOptions)
    },
    // 深度查询是否必填
    DeepCheckIsRquire(name) {
      let fieldObj = this.GetFieldObj(name)
      if (fieldObj.isRelated) {
        let fatherObj = this.GetFieldObj(fieldObj.relatedField)
        if (!fatherObj.isRelated) {
          let innerValue = this.GetFieldValue(fieldObj.relatedField)
          if (innerValue === fieldObj.relatedValue) {
            return true
          } else {
            return false
          }
        } else {
          let fatherStatus = this.DeepCheckIsRquire(fatherObj.name)
          if (!fatherStatus) {
            return false
          } else {
            let fatherValue = this.GetFieldValue(fatherObj.name)
            if (fatherValue === fieldObj.relatedValue) {
              return true
            } else {
              return false
            }
          }
        }

      } else {
        return false
      }

    },
    // 获取字段对象
    GetFieldObj(name) {
      let obj = {}
      this.attendeeOptions.map(item => {
        if (item.name === name) {
          obj = ObjectDeepClone(item)
        }
      })
      return obj
    },
    // 手机验证码发生变化
    verifyCodeChange(value) {
      this.verifyCode = value
    },
    // 获取当前的值
    GetFieldValue(itemName) {
      let value = ''
      this.attendeeOptions.map((item) => {
        if (item.name === itemName) {
          value = item.value
        }
      })
      return value
    },
    // 处理关联字段配置
    IsRelated(item) {
      // 判断是否展示
      if (item.rank.form.field.isShow) {
        // 判断是否关联字段
        if (item.isRelated) {
          let innerItem = this.fieldsData[item.relatedField]
          if (!innerItem.isRelated) {
            let fieldValue = this.GetFieldValue(innerItem.name)
            if (fieldValue === item.relatedValue) {
              return true
            } else {
              return false
            }
          } else {
            let fatherStatus = this.IsRelated(innerItem)
            if (!fatherStatus) {
              return false
            } else {
              let fieldValue = this.GetFieldValue(innerItem.name)
              if (fieldValue === item.relatedValue) {
                return true
              } else {
                return false
              }
            }
          }
        } else {
          return true
        }
      } else {
        return false
      }
    },
    // 处理逻辑关联数据
    DealRelationShip() {
      let tempObj = {}
      this.attendeeOptions.map((item) => {
        tempObj[item.name] = this.IsRelated(item)
      })
      this.RelatedObj = tempObj
    },
    // 删除非必填数据
    DelnoRequireDatas(values) {
      return new Promise(resolve => {
        let tempDatas = ObjectDeepClone(values)
        Object.keys(values).map(item => {
          let tempObj = this.GetFieldObj(item)
          if (tempObj.isRelated && !tempObj.isRequire && (values[tempObj.relatedField] !== tempObj.relatedValue)) {
            tempDatas[item] = ""
          }
        })
        resolve(tempDatas)
      })
    },
    // 校验不通过
    onFailed() {
      this.$notify({
        type: 'warning',
        message: this.$t('notify.noFinish'),
      })
      this.$emit('listenResetSubmitStatus')
    },
    // 数据提交前判断是否进行验证码校验
    HasVerifyCodeCheck(values) {
      return new Promise((resolve, reject) => {
        if (
          this.fieldsData.mobile_phone &&
          this.fieldsData.mobile_phone.isSendVerifyCode
        ) {
          if (this.verifyCode.trim().length === 0) {
            reject('请填写验证码')
          } else if (this.verifyCode.trim().length !== 6) {
            reject('验证码格式不正确')
          } else {
            let resdata = {
              account_uid: this.params.accountid,
              project_uid: this.params.projectid,
              mobile_phone: values.mobile_phone,
              code: this.verifyCode,
            }
            ResForCheckVerifyCode(resdata)
              .then(() => {
                resolve()
              })
              .catch(() => {
                this.submiting = false
              })
          }
        } else {
          resolve()
        }
      })
    },
    // 重置校验信息
    resetValidation(name) {
      this.$refs.attendeeForm.resetValidation(name, '')
    },
    // 表单内容发生改变
    OptionValueChanged(name, value) {
      this.attendeeOptions.map((item) => {
        if (item.name === name) {
          item.value = value
        }
      })
    },
    // 多选框值发生变化
    CheckboxValueChange(name, value) {
      this.attendeeOptions.map(item => {
        if (item.name === name) {
          item.value = value
        }
      })
    },
    // 单选和选择器值发生变化
    RadioOrPickerChanged(name, value) {
      // console.log(name, value)
      this.attendeeOptions.map((item) => {
        if (item.name === name) {
          item.value = value
        }
      })
      // 判断及调整关联字段必填项
      this.JudgeRelatedisRequire()
    },
    // 判断及调整关联字段必填项
    JudgeRelatedisRequire() {
      let options = ObjectDeepClone(this.attendeeOptions)
      options.map(item => {
        if (item.tempRequire && item.isRelated) {
          item.isRequire = this.DeepCheckIsRquire(item.name)
        }
      })
      this.attendeeOptions = ObjectDeepClone(options)
    },
    // input输入数据变化
    InputValueChanged(name, value) {
      console.log(name, value)
    },
    // 字段关联关系判断
    relationFunc(obj) {
      const tempUserVal = this.attendeeOptions[obj.relationFiled].userValue
      const tempRelaVal = obj.relationValue
      return relationCheck[obj.relationType](tempUserVal, tempRelaVal)
    },
    // 图片列表发生变化
    ImgListChanged(name, imglist) {
      this.setImgOptionVal(name, imglist[0])
      let isInArr = false
      this.imgfieldArr.map((item) => {
        if (item.name === name) {
          isInArr = true
          item.imgList = imglist
        }
      })
      if (!isInArr) {
        this.imgfieldArr.push({
          name: name,
          imgList: imglist,
        })
      }
    },
    // 头像列表发生变化
    AvatarListChanged(name, imglist) {
      this.setImgOptionVal(name, imglist[0])
      let isInArr = false
      this.avatarfieldArr.map((item) => {
        if (item.name === name) {
          isInArr = true
          item.imgList = imglist
        }
      })
      if (!isInArr) {
        this.avatarfieldArr.push({
          name: name,
          imgList: imglist,
        })
      }
    },
    // 照片、图片赋值
    setImgOptionVal(name, val) {
      this.attendeeOptions.forEach(item => {
        if (item.name === name) {
          item.val = val
          return
        }
      })
    },
    // 名片识别完成
    aiBusinessCardFinish(info) {
      // console.log(info)
      // console.log(this.attendeeOptions)
      let tempInfo = ObjectDeepClone(this.attendeeOptions)
      Object.keys(info).map(key => {
        tempInfo.forEach(opItem => {
          if (opItem.name === key) {
            opItem.value = info[key].value
            return
          }
        })
      })
      // console.log(tempInfo)
      this.attendeeOptions = tempInfo
    },
    // 提交前数据处理
    DealDataBeforeSubmit(data) {
      return new Promise((resolve) => {
        // 处理照片
        if (this.avatarfieldArr.length > 0) {
          this.avatarfieldArr.map((avatarItem) => {
            Object.keys(data).map((key) => {
              if (avatarItem.name === key) {
                let tempStr = ''
                // console.log(avatarItem)
                avatarItem.imgList.map((listItem) => {
                  tempStr += `${listItem}|`
                })
                data[key] = tempStr.substr(0, tempStr.length - 1)
              }
            })
          })
        }

        // 处理图片
        if (this.imgfieldArr.length > 0) {
          this.imgfieldArr.map((imgItem) => {
            Object.keys(data).map((key) => {
              if (imgItem.name === key) {
                let tempStr = ''
                imgItem.imgList.map((listItem) => {
                  tempStr += `${listItem}|`
                })
                data[key] = tempStr.substr(0, tempStr.length - 1)
              }
            })
          })
        }

        // 处理多选框
        if (this.verifyboxArr.length > 0) {
          this.verifyboxArr.map((key) => {
            let tempArr = ObjectDeepClone(data[key])
            let tempStr = ''
            tempArr.map((valItem) => {
              tempStr += `${valItem}|`
            })
            data[key] = tempStr.substr(0, tempStr.length - 1)
          })
        }
        resolve(data)
      })
    },
    // 提交数据
    onSubmit(values) {
      // console.log('wanna submit')
      // console.log(values)
      this.HasVerifyCodeCheck(values).then(() => {
        this.DealDataBeforeSubmit(values).then(data => {
          this.DelnoRequireDatas(data).then(infos => {
            // console.log(infos)
            this.$emit('listenformDataCheckFinish', infos)
          })
        })
      }).catch((msg) => {
        console.log(msg)
        this.$notify({
          type: 'warning',
          message: msg,
        })
        this.$emit('listenResetSubmitStatus')
      })
    }

  },

  mounted() {
    this.GetParamsData()
  },
}
</script>
<style lang='less' scoped>
</style>